import React from 'react'
import classnames from 'classnames'
import PropTypes from 'prop-types'
import Text from '../Text/Text'

import styles from './sidebar.module.scss'

const MenuItem = ({ currentPath, history, menu }) => {
  const active = menu.route === currentPath

  const classMenuItem = classnames(styles.menuItem, {
    [styles.active]: active
  })

  return (
    <li
      onClick={() => history.push(menu.route)}
      className={classMenuItem}
      key={menu.optionId}
    >
      {menu.icon}
      <Text
        className={styles.menuLabel}
        size="xs"
        color="gray"
        value={menu.name}
        fontWeight="300"
        font="custom"
      />
    </li>
  )
}

MenuItem.propTypes = {
  menu: PropTypes.shape({
    icon: PropTypes.element,
    name: PropTypes.string,
    route: PropTypes.string,
    optionId: PropTypes.number
  }).isRequired,
  currentPath: PropTypes.string.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func
  }).isRequired
}

export default MenuItem
